import facebookAuthProvider from "./facebookAuthProvider";
import appleAuthProvider from "./appleAuthProvider";
import { PodiyaAuthProvider } from "../../types";

import type { AuthProvider } from 'react-admin';
import { sessionStorageUserDataKey } from "../../constants";

let authProvider: AuthProvider | undefined = undefined;

const login = ({ authProviderName, ...otherParams }: { authProviderName: PodiyaAuthProvider; [key: string]: any }) => {
  if (authProviderName === PodiyaAuthProvider.Apple) {
    authProvider = appleAuthProvider;
  } else if (authProviderName === PodiyaAuthProvider.Facebook) {
    authProvider = facebookAuthProvider;
  } else {
    return Promise.reject('Attempted to login using uninitialized auth provider bridge');
  }

  return authProvider.login(otherParams);
}

const logout = (params: any) => {
  if (!authProvider) {
    return Promise.resolve();
  }

  return authProvider.logout(params).then((res) => {
    authProvider = undefined;
    return res;
  });
}

const checkError = (error: any) => {
  if (!authProvider) {
    return Promise.reject('Attempted to checkError using uninitialized auth provider bridge');
  }

  return authProvider.checkError(error);
}

const checkAuth = (params: any) => {
  if (!authProvider) {
    return Promise.reject('Unauthorized');
  }

  return authProvider.checkAuth(params);
}

const getPermissions = async () => {
  const roleDataJson = sessionStorage.getItem(sessionStorageUserDataKey);

  if (!roleDataJson) {
    return Promise.reject();
  }

  const { role } = JSON.parse(roleDataJson);

  return role ? Promise.resolve(role) : Promise.reject();
}

const getIdentity = () => {
  try {
    const userDataJson = sessionStorage.getItem(sessionStorageUserDataKey);
    if (!userDataJson) {
      return Promise.reject();
    }

    const { id, firstName, lastName, extId, nickname, avatarLink, countryId } = JSON.parse(userDataJson);
    return Promise.resolve({
      id,
      fullName: `${firstName} ${lastName}`,
      avatar: avatarLink,
      extId,
      nickname,
      countryId,
    });
  } catch (error) {
    return Promise.reject(error);
  }
}

const authProviderBridge: AuthProvider = {
  login,
  logout,
  checkError,
  checkAuth,
  getPermissions,
  getIdentity,
};

export default authProviderBridge;

